/**
 * MAIN JS FILE
 */

/**
 * Helpers
 * Imports of helper functions are stripped out of bundle
 * Include them within "start-strip-code" and "end-strip-code" comments
 */
/* start-strip-code */
import GridHelper from "./helpers/GridHelper";
/* end-strip-code */
/**
 * Components
 */
import SliderInstance from "./components/SliderInstance";
import NavigationController from "./components/NavigationController";
import SlimSelect from "slim-select";
import ModalController from "./components/ModalController";
import ShowPasswordToggle from "./components/ShowPasswordToggle";
import Accordion from "@bornfight/b-accordion";
import CookieButtonController from "./components/CookieButtonController";
import CookiePopupController from "./components/CookiePopupController";
import VideoPlaylist from "./components/VideoPlaylist";
import DoctorsTabs from "./components/DoctorsTabs";
import BmiCalculator from "./components/BmiCalculator";
import BmrCalculator from "./components/BmrCalculator";
import DonutChart from "./components/DonutChart";
import Litepicker from 'litepicker';
import OvulationCalendar from "./components/OvulationCalendar";
import YoutubeVideoPlayer from "./components/VideoYTPlayer";

/**
 * Check if document is ready cross-browser
 * @param callback
 */
const ready = (callback) => {
    if (document.readyState !== "loading") {
        /**
         * Document is already ready, call the callback directly
         */
        callback();
    } else if (document.addEventListener) {
        /**
         * All modern browsers to register DOMContentLoaded
         */
        document.addEventListener("DOMContentLoaded", callback);
    } else {
        /**
         * Old IE browsers
         */
        document.attachEvent("onreadystatechange", function () {
            if (document.readyState === "complete") {
                callback();
            }
        });
    }
};

/**
 * Document ready callback
 */
ready(() => {
    /**
     * HELPERS INIT
     * Only init helpers if they exist
     * Will be undefined on production because of import stripping
     */
    if (typeof GridHelper == "function") {
        const grid = new GridHelper();
        grid.init();
    }

    /**
     * COMPONENTS INIT
     */

    /**
     * Navigation
     * @type {NavigationController}
     * only on desktop
     */
    const navigation = new NavigationController();
    navigation.init();

    /**
     * Custom select box
     * @type {NodeListOf<Element>}
     */
    const selectBox = document.querySelectorAll(".js-select-box");
    if (selectBox.length > 0) {
        for (let i = 0; i < selectBox.length; i++) {
            const placeholderText = selectBox[i].dataset.placeholderText;
            new SlimSelect({
                select: selectBox[i],
                showSearch: false,
                placeholder: placeholderText ? placeholderText : "",
            });
        }
    }

    /**
     * Related slider instance
     */
    const articleSlider = document.querySelector(".js-article-slider");
    if (articleSlider !== null) {
        new SliderInstance(articleSlider, {});
    }

    /**
     * Doctors slider instance
     */
    const doctorsSlider = document.querySelector(".js-doctors-slider");
    if (doctorsSlider !== null) {
        new SliderInstance(doctorsSlider, {
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                480: {
                    slidesPerView: 1,
                },
                510: {
                    slidesPerView: 2,
                },
                640: {
                    slidesPerView: 3,
                },
                800: {
                    slidesPerView: 4,
                },
                1140: {
                    slidesPerView: 5,
                }
            },
        });
    }

    /**
     * Tools slider instance
     */
    // const toolsSlider = document.querySelector(".js-tools-slider");
    // if (toolsSlider !== null) {
    //     new SliderInstance(toolsSlider, {
    //         slidesPerView: 1,
    //         spaceBetween: 0,
    //         breakpoints: {
    //             480: {
    //                 slidesPerView: 2,
    //             },
    //             960: {
    //                 slidesPerView: 4,
    //                 allowTouchMove: false,
    //             },
    //         },
    //     });
    // }

    /**
     * Videos slider instance
     */
    const videosSlider = document.querySelector(".js-videos-slider");
    if (videosSlider !== null) {
        if (window.innerWidth <= 800) {
            new SliderInstance(videosSlider, {
                slidesPerView: 1.1,
                spaceBetween: 0,
                breakpoints: {
                    560: {
                        slidesPerView: 2,
                    },
                    800: {
                        slidesPerView: 4,
                        allowTouchMove: false,
                    },
                },
            });
        }
    }

    /**
     * Videos slider instance - below hero
     */
    const videosSliderBlogSingle = document.querySelectorAll(".js-videos-slider__blog_single");
    if (videosSliderBlogSingle !== null) {
        videosSliderBlogSingle.forEach((slider, index) => {
            new SliderInstance(slider, {
                slidesPerView: 1.1,
                spaceBetween: 0,
                breakpoints: {
                    560: {
                        slidesPerView: 2,
                    },
                    800: {
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },
                },
            });
        });
    }

    
    /**
     * Tools slider instance 3 columns
     */
    // const toolsThreeColSlider = document.querySelector(".js-tools__3_col-slider");
    // if (toolsThreeColSlider !== null) {
    //     new SliderInstance(toolsThreeColSlider, {
    //         slidesPerView: 1,
    //         spaceBetween: 0,
    //         breakpoints: {
    //             480: {
    //                 slidesPerView: 2,
    //             },
    //             960: {
    //                 slidesPerView: 3,
    //                 allowTouchMove: false,
    //             },
    //         },
    //     });
    // }

    /**
     * Modal controller
     * @type {ModalController}
     */
    const modalController = new ModalController();
    modalController.init();

    /**
     * Show password toggle
     * @type {ShowPasswordToggle}
     */
    const passwordToggle = new ShowPasswordToggle();
    passwordToggle.init();

    /**
     * Accordion
     * @type {Accordion}
     */
    new Accordion();

    /**
     * Cookie button label toggle
     * @type {CookieButtonController}
     */
    const cookieButtonController = new CookieButtonController();
    cookieButtonController.init();

    /**
     * Cookie popup controler
     * @type {CookiePopupController}
     */
    const cookiePopupController = new CookiePopupController();
    cookiePopupController.init();

    /**
     * Doctors tabs
     * @type {DoctorsTabs}
     */
    const doctorsTabs = new DoctorsTabs();
    doctorsTabs.init();

    /**
     * Video playlist
     * @type {VideoPlaylist}
     */
    const videoPlaylist = new VideoPlaylist();
    videoPlaylist.init();

    /**
     * Bmi calculatore
     * @type {BmiCalculator}
     */
    const bmiCalculator = new BmiCalculator();
    bmiCalculator.init();

    /**
     * Bmr calculator
     * @type {BmrCalculator}
     */
    const bmrCalculator = new BmrCalculator();
    bmrCalculator.init();

    /**
     * Donut chart
     * @type {DonutChart}
     */
    const donutChart = new DonutChart();
    donutChart.init();

    /**
     * Ovulation calendar
     * @type {OvulationCalendar}
     */
    const ovulationCalendar = new OvulationCalendar();
    ovulationCalendar.init();

    /**
     * Youtube video player
     * @type {YoutubeVideoPlayer}
     */
    const youtubeVideoPlayer = new YoutubeVideoPlayer();
    youtubeVideoPlayer.init();
});
